import { EpalUnitDetails } from './../common/models/epalunitdetails';
import { EpalCommissionFilter } from './../common/models/epalcommissionfilter';
import { GridOptions } from 'ag-grid-community';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AgGridAngular } from 'ag-grid-angular';
import { FCToasterService } from '../common/toaster/FCToasterService';
import { Service } from '../service';
import { EpalCommission } from '../common/models/epalcommission';
import { EpalDecomAndComm } from '../common/models/EpalDecomAndComm';
import { EpalRebootRequest } from '../common/models/epalRebootRequest';
import { AddContentToDevice } from '../common/models/addcontenttodevice';
import { EpalGatewayDecommission } from '../common/models/epalgatewaydecommission';
import { AssignEpalGateway } from '../common/models/assignepalgateway';
import { unitSearchService } from '../common/unitSearchService';
import { DraggableModalComponent } from '../common/popupmodel/draggable-modal.component';
import { ModalConfig } from '../common/modal-config';
import { EpalDecommission } from '../common/models/epaldecommission';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { EloviewSyncComponent } from '../eloview-sync/eloview-sync.component';
import { PermissionService } from '../services/permission.service';
import { catchError, forkJoin, of } from 'rxjs';
import { MasterDataService } from '../services/master-data.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-epalcommission',
  templateUrl: './epalcommission.component.html',
  styleUrls: ['./epalcommission.component.scss'],
  standalone: false
})
export class EpalcommissionComponent implements OnInit {
  permissionService: PermissionService;
  @ViewChild("agGridCommission", { static: false }) agGridCommission: AgGridAngular;
  @ViewChild('tabGroup', { static: false }) tabGroup: MatTabGroup;
  @ViewChild(EloviewSyncComponent) eloViewSyncInfo: EloviewSyncComponent;
  closeResult: string;
  rowData: any[];
  columnDefs: any[];
  gridOptions: GridOptions;
  unitNumbers: any[];
  selectedUnits = [];
  ePALCommissionedGateways: any[];
  ePALCommissionedDevices: any[] = [];
  expandedCommissionedDeviceIndex: number = -1;
  ePALBuildingDetails: EpalUnitDetails;
  searchFilter = {} as EpalCommissionFilter;
  txtePALSrchBldId: any;
  txtePALSrchBldName: any;
  txtePALSrchBldAdd: any;
  txtePALSrchUnitNum: any;
  isRowSelected: boolean = false;
  rowSelectedData: {};
  selectedBuilding = [];
  lblMdlBldId: any;
  lblMdlBldName: any;
  txtMLePALHardwareId: any;
  lblComErrorePALHardwareId: string;
  lblMLEloviewSerialNum: string;
  lblDeComErrorePALHardwareId: string;
  lblComErrorTestBldId: string;
  ePALcommission = {} as EpalCommission;
  ePALDecomAndComm = {} as EpalDecomAndComm;
  ePALDeviceReboot = {} as EpalRebootRequest;
  ePALAddContentToDevice = {} as AddContentToDevice;
  ePALGatewayDecommission = {} as EpalGatewayDecommission;
  epalDecommission = {} as EpalDecommission;
  txtEpalHardwareId: string;
  deComEpalHwId: string;
  txtMdlePALTestBldId: any;
  txtMLEloviewSerialNum: any;
  isBtnStartEpal: boolean = true;
  isBtnEndEpal: boolean = false;
  appContent: any[];
  appContentV3: any[];
  appContentV4: any[];
  appContentSelectedId: number;
  appContentSelectedValue: string;
  appContentError: string = "";
  eloViewDeviceError: string = "";
  Devicegateway: any[];
  devicegatewayTypeSelId: number = 2;
  gatewayTypes: any[];
  gatewayTypeSelectedId: number;
  gatewayTypeSelectedValue: any;
  txtGWMlMacAdd: any;
  txtGWMlIccId: string;
  txtGWMlIccId2: string;
  txtGWPwd: string;
  lblErrorGWMLMacAdd = "";
  assignEpalGateway = {} as AssignEpalGateway;
  defaultGatewayTypeText: string = "DIGI-EX12";
  defaultGatewayTypeId: number = 3;
  defaultMacAddress: string = "002704";
  txtECfwVersion: any;
  selTxtECfwVersion: any;
  txtGWFirmwareVersion: any;
  txtECSuggestedVersion = "";
  lblVersionMessage = "";
  isVersionMatch: boolean = true;
  GWFMVersion: any;
  gatewayUpdateEnabled: boolean = false;
  txtEloViewDevice: any;
  temptxtEloViewDevice: any;
  eloViewDeviceID: any;
  eloviewDeviceStatus: boolean = null;
  strUnitNumbers: string = "";
  lblNewDeviceName: string = "";
  modalRef: any;
  modalOptions: NgbModalOptions = ModalConfig;
  enableEloViewSync = false;
  eloViewSync: string = "";
  selEloVersionNumber: number = 3;
  isEnvironmentDisabled: boolean = false;
  lblICCID2error = "";
  lblICCID2success = "";
  lblICCID1error = "";
  lblICCID1success = "";
  lblVerizonStatus = "";
  lblATTStatus = "";
  isVerizonActivation: boolean = false;
  isATTActivation: boolean = false;
  verizonDeviceInfo: any;
  attDeviceInfo: any;
  isInvalidSim1: boolean = false;
  isInvalidSim2: boolean = false;

  defaultEloVersionId: number = 3;

  constructor(private apiService: Service, private modalService: NgbModal,
    private toastr: FCToasterService, private unitSearch: unitSearchService,
    private permissionServiceParam: PermissionService,
    private masterDataService: MasterDataService,
    private oauthService: OAuthService
  ) {
    this.permissionService = permissionServiceParam;
  }

  ngOnInit(): void {
    let claims = this.oauthService.getIdentityClaims();
    this.apiService
      .getUserDetails(claims["oid"])
      .subscribe({
        next: (data: any) => {
          if (data != null) {
            this.defaultEloVersionId = data["defaultEloVersionId"] == null ? this.defaultEloVersionId : data["defaultEloVersionId"];
            this.selEloVersionNumber = this.defaultEloVersionId;
          }
        },
        error: () => {
        }
      });
    this.bindDefaultValuesOnLoad();
    this.bindGridOnPageLoad();
    this.checkUserPermissions();

    this.gridOptions = {
      defaultColDef: { filter: true },
      localeText: { noRowsToShow: 'No records found' },
      animateRows: true,
      pagination: true,
      paginationAutoPageSize: true,
      headerHeight: 40,
      rowHeight: 32
    }
  }

  openModal() {
    this.modalRef = this.modalService.open(DraggableModalComponent, this.modalOptions);
    this.modalRef.componentInstance.title = 'Drag Me!';
    this.modalRef.componentInstance.message = 'Try dragging this modal around using the modal header!';
    this.modalRef.componentInstance.onSubmitSubject
      .subscribe((res: boolean) => {

      });
  }

  bindDefaultValuesOnLoad() {
    this.txtePALSrchBldId = "";
    this.txtePALSrchBldName = "";
    this.txtePALSrchBldAdd = "";
    this.txtePALSrchUnitNum = "";
    this.rowSelectedData = {};
    this.isRowSelected = false;
    this.lblMdlBldId = "";
    this.lblMdlBldName = "";
    this.txtMLePALHardwareId = "";
    this.selectedBuilding = [];
    this.rowData = [];
    this.lblComErrorePALHardwareId = "";
    this.lblDeComErrorePALHardwareId = "";
    this.lblComErrorTestBldId = "";
    this.txtEpalHardwareId = "";
    this.deComEpalHwId = "";
    this.ePALBuildingDetails = new EpalUnitDetails();
    this.txtMdlePALTestBldId = "";
    this.txtMLEloviewSerialNum = "";
    this.isBtnStartEpal = true;
    this.isBtnEndEpal = false;
    this.appContentSelectedId = 0;
    this.appContentSelectedValue = "";
    this.appContentError = "";
    this.eloViewDeviceError = "";
    this.gatewayTypeSelectedValue = this.defaultGatewayTypeText;
    this.gatewayTypeSelectedId = this.defaultGatewayTypeId;
    this.txtGWMlMacAdd = this.defaultMacAddress;
    this.txtGWMlIccId = "";
    this.txtGWMlIccId2 = "";
    this.txtGWPwd = "";
    this.lblVersionMessage = "";
    this.txtEloViewDevice = "";
    this.temptxtEloViewDevice = "";
    this.eloViewDeviceID = "";
    this.getDeviceGatewayTypes();
    this.getGatewayTypes();
    this.getGatewayFirmwareVersion();
    this.eloviewDeviceStatus = null;
    this.strUnitNumbers = "";
    this.lblNewDeviceName = "";
    this.lblICCID2error = "";
    this.lblICCID2success = "";
    this.lblICCID1error = "";
    this.lblICCID1success = "";
    this.lblVerizonStatus = "";
    this.lblATTStatus = "";
    this.isVerizonActivation = false;
    this.isATTActivation = false;
    this.verizonDeviceInfo = [];
    this.attDeviceInfo = [];
    this.isInvalidSim1 = false;
    this.isInvalidSim2 = false;
  }

  getGatewayFirmwareVersion() {
    this.apiService
      .getGatewayFirmwareVersion()
      .subscribe((data: any) => {
        this.GWFMVersion = data;
        this.gatewayTypeSelectedId = this.defaultGatewayTypeId;
        const emptyVersionData = this.getEmptyGatewayFirmwareVersion(this.gatewayTypes, data);
        emptyVersionData.forEach(element => {
          this.GWFMVersion.push({
            gatewayTypeId: element.id,
            name: element.name,
            firmwareVersion: "N/A",
            createdBy: "N/A"
          })
        });
        this.getGatewayFirmwareVersionName(Number(this.gatewayTypeSelectedId));
      });
  }

  getEmptyGatewayFirmwareVersion(gatewaytype, data) {
    let res = [];
    if (gatewaytype != undefined) {
      res = gatewaytype.filter(el => {
        return !data.find(element => {
          return element.gatewayTypeId === el.id;
        });
      });
      return res;
    }
  }

  getGatewayFirmwareVersionName(gatewayType) {
    var fwversion;
    this.GWFMVersion.forEach(element => {
      fwversion = "";
      if (element.gatewayTypeId === gatewayType) {
        if (element.firmwareVersion.indexOf(',') > -1) {
          //This code will add first element concatenating two versions
          fwversion = element.firmwareVersion.replace(',', '  |  ') + ',';
        }
        this.txtECfwVersion = fwversion + element.firmwareVersion;
        this.selTxtECfwVersion = element.firmwareVersion.split(',')[0];
        return true;
      }
    });
  }

  fmOOCVersionSelectChanged($event) {
    this.selTxtECfwVersion = $event.target.value;
  }

  ClearValuesOnsave() {
    this.devicegatewayTypeSelId = 2;
    this.gatewayTypeSelectedId = this.defaultGatewayTypeId;
    this.getGatewayFirmwareVersionName(Number(this.gatewayTypeSelectedId));
    this.txtGWMlMacAdd = this.defaultMacAddress;
    this.txtGWMlIccId = "";
    this.txtGWMlIccId2 = "";
    this.txtGWPwd = "";
    this.lblErrorGWMLMacAdd = "";
    this.gatewayUpdateEnabled = false;
    this.lblVersionMessage = "";
    this.txtECSuggestedVersion = "";
    this.lblICCID2error = "";
    this.lblICCID2success = "";
    this.lblICCID1error = "";
    this.lblICCID1success = "";
    this.lblVerizonStatus = "";
    this.lblATTStatus = "";
    this.isVerizonActivation = false;
    this.isATTActivation = false;
    this.verizonDeviceInfo = [];
    this.attDeviceInfo = [];
    this.isInvalidSim1 = false;
    this.isInvalidSim2 = false;

  }

  bindGridOnPageLoad() {
    this.columnDefs = [
      { headerName: "", field: "cbox", checkboxSelection: true, width: 70, flex: 0 },
      { headerName: "Building Id", field: "buildingId", sortable: true, minWidth: 250, flex: 2.5, tooltipField: "buildingId", headerTooltip: "Building Id" },
      { headerName: "Building Name", field: "buildingName", sortable: true, minWidth: 300, flex: 3, tooltipField: "buildingName", headerTooltip: "Building Name" },
      { headerName: "Building Address", field: "buildingAddress", sortable: true, minWidth: 400, flex: 4, resizable: true, tooltipField: "buildingAddress", headerTooltip: "Building Address" },
      { headerName: "Building City", field: "buildingCity", sortable: true, minWidth: 250, flex: 2.5, resizable: true, tooltipField: "buildingCity", headerTooltip: "Building City" },
    ];
    this.getGridDataByFilterSearch();
    this.getEloViewAppContent();
    this.getDeviceGatewayTypes();
    this.getGatewayTypes();
  }

  getGridDataByFilterSearch() {
    this.searchFilter.buildingId = (this.txtePALSrchBldId !== null && this.txtePALSrchBldId !== undefined) ? this.txtePALSrchBldId.trim() : "";
    this.searchFilter.buildingName = (this.txtePALSrchBldName !== null && this.txtePALSrchBldName !== undefined) ? this.txtePALSrchBldName.trim() : "";
    this.searchFilter.buildingAddress = (this.txtePALSrchBldAdd !== null && this.txtePALSrchBldAdd !== undefined) ? this.txtePALSrchBldAdd.trim() : "";
    if (this.txtePALSrchUnitNum !== null && this.txtePALSrchUnitNum !== undefined) {
      this.searchFilter.elevatorUnitNumber = this.unitSearch.getUpdatedUnitSearch(this.txtePALSrchUnitNum.trim());
    }
    else {
      this.searchFilter.elevatorUnitNumber = "";
    }
    this.isRowSelected = false;
    this.rowSelectedData = {};
    this.selectedBuilding = [];

    this.apiService
      .getBuildingDetailsByFilterSearch(this.searchFilter)
      .subscribe((data: any) => {
        if (data != null) {
          this.rowData = [];
          this.rowData = data;
        }
        else {
          this.rowData = [];
        }
      });
  }

  resetFilters(event) {
    this.bindDefaultValuesOnLoad();
    this.bindGridOnPageLoad();
  }

  onEnvironmentSelectChanged($event) {
    this.setAppContentBasedOnVersion();
    this.appContentSelectedId = 0;
  }

  getEloViewAppContent() {
    forkJoin({
      v3: this.apiService.getEloViewAppContent(3).pipe(catchError(() => of([]))),
      v4: this.apiService.getEloViewAppContent(4).pipe(catchError(() => of([])))
    }).subscribe((result: any) => {
      this.appContentV3 = result.v3;
      this.appContentV4 = result.v4;

      this.setAppContentBasedOnVersion();
    });
  }

  private setAppContentBasedOnVersion() {
    if (Number(this.selEloVersionNumber) === 3) {
      this.appContent = this.appContentV3;
    } else if (Number(this.selEloVersionNumber) === 4) {
      this.appContent = this.appContentV4;
    }
  }

  getEloViewDevices(isStartTest: boolean) {
    this.apiService
      .getEloViewDevices(this.txtMLEloviewSerialNum.trim(), this.lblMdlBldId.trim(), this.selEloVersionNumber)
      .subscribe((data: any) => {
        if (data != null) {
          this.temptxtEloViewDevice = data.deviceName;
          this.txtEloViewDevice = data.deviceName + ' - ' + data.hardwareId;
          this.eloViewDeviceID = data.deviceId;
          this.eloviewDeviceStatus = data.deviceStatus;
          this.eloViewDeviceError = "";
          this.isEnvironmentDisabled = true;
          if (isStartTest) {
            this.isBtnStartEpal = false;
            this.isBtnEndEpal = true;
          }
        }
        else {
          this.temptxtEloViewDevice = "";
          this.txtEloViewDevice = "";
          this.eloViewDeviceID = "";
          this.isEnvironmentDisabled = false;
        }
      });
  }

  onContentSelectChanged($event) {
    this.appContentSelectedId = $event.target.value;
    this.appContentSelectedValue = $event.target.options[$event.target.selectedIndex].text;
    if (this.appContentSelectedId !== 0) {
      this.appContentError = "";
    }
  }

  //Grid row selection event
  onRowSelected(event) {
    this.strUnitNumbers = "";
    this.selectedUnits = [];
    if (event.node.selected) {
      this.selectedBuilding.push(event.node.data);
    }
    else {
      var index = this.selectedBuilding.indexOf(event.node.data);
      this.selectedBuilding.splice(index, 1);
    }

    if (this.selectedBuilding.length === 1) {
      this.isRowSelected = true;
      this.rowSelectedData = this.selectedBuilding[0];
      this.ePALCommModalLoad(this.rowSelectedData);
      this.ePALGatewayModalLoad(this.rowSelectedData);
      this.getGatewayFirmwareVersionName(Number(this.gatewayTypeSelectedId));
    }
    else {
      this.isRowSelected = false;
      this.rowSelectedData = {};
    }
  }

  ePALCommModalLoad(rowSelectedData) {
    this.expandedCommissionedDeviceIndex = -1;
    this.lblMdlBldId = (rowSelectedData["buildingId"] !== null && rowSelectedData["buildingId"] !== undefined) ? rowSelectedData["buildingId"] : "";
    this.lblMdlBldName = (rowSelectedData["buildingName"] !== null && rowSelectedData["buildingName"] !== undefined) ? rowSelectedData["buildingName"] : "";
    this.txtGWMlIccId = rowSelectedData["simcardICCID1"] || rowSelectedData["simCardICCID1"] || rowSelectedData["simcardIccId1"] || rowSelectedData["simCardIccId1"] || "";
    this.txtGWMlIccId2 = rowSelectedData["simcardICCID2"] || rowSelectedData["simCardICCID2"] || rowSelectedData["simcardIccId2"] || rowSelectedData["simCardIccId2"] || "";

    if (this.lblMdlBldId !== null && this.lblMdlBldId !== "" && this.lblMdlBldId !== undefined) {
      forkJoin({
        unitDetails: this.apiService.getUnitDetailsByBuildingId(this.lblMdlBldId),
        commissionedDevices: this.apiService.getePALCommissionedDevices(this.lblMdlBldId)
      }).subscribe((result: any) => {
        if (result.unitDetails != null) {
          this.unitNumbers = result.unitDetails;
          for (var val of this.unitNumbers) {
            this.selectedUnits.push(val['elevatorUnitNumber']);
            this.strUnitNumbers = this.strUnitNumbers.length > 0 ? this.strUnitNumbers + ", " + val['elevatorUnitNumber'] : val['elevatorUnitNumber'];
          }
        }
        else {
          this.unitNumbers = [];
          this.selectedUnits = [];
        }

        if (result.commissionedDevices != null) {    
          this.ePALCommissionedDevices = result.commissionedDevices;
        }
        else {
          this.ePALCommissionedDevices = [];
        }
      });
    }
  }

  // Commission Modal Popup
  open(content) {
    this.lblComErrorePALHardwareId = "";
    this.lblDeComErrorePALHardwareId = "";
    this.lblComErrorTestBldId = "";
    this.ClearValuesOnsave();

    if (content._declarationTContainer.localNames[0] == 'UpdateEloViewDevice') {
      this.modalService.open(content, { windowClass: "eloUpdateStyle", ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
    else {
      this.modalService.open(content, { windowClass: "myCustomModalePALClass", ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false, centered: true }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  }

  // Close Modal Popup
  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  // Close Modal Popup
  modalClose(content) {
    this.modalService.dismissAll();
    this.resetDeCommModal();
    this.resetCommModal();
    this.txtGWMlMacAdd = this.defaultMacAddress;
    this.lblICCID1error = "";
    this.lblICCID1success = "";
    this.lblICCID2error = "";
    this.lblICCID2success = "";
    this.lblVerizonStatus = "";
    this.lblATTStatus = "";
    this.isVerizonActivation = false;
    this.verizonDeviceInfo = [];
    this.attDeviceInfo = [];
    this.isInvalidSim1 = false;
    this.isInvalidSim2 = false;
  }

  onKeyEnter() {
    this.getGridDataByFilterSearch();
  }

  //ePAL HwID Commission for Test Building Id
  onEpalCommForTestBld(isUpdateDevice) {
    if (this.onEpalCommValidation()) {
       if (this.lblICCID2error != "") {
          this.txtGWMlIccId2 = "";
          this.lblICCID2error = "";
          setTimeout(() => {
            this.toastr.showInformation("SIM ICCID2 not found in the Verizon system. Please update SIM details offline");
          }, 5000);
        }

      if (isUpdateDevice) {
        if (this.txtEloViewDevice != "") {
          this.lblNewDeviceName = this.appContentSelectedValue + ": " + this.lblMdlBldName + ": " + this.txtMLePALHardwareId + ": " + this.strUnitNumbers
          let lblctrl = document.getElementById('lblUpdDevice') as HTMLElement;
          lblctrl.click();
          return false;
        }
      }
      else {
        let lblctrl = document.getElementById('btnClose') as HTMLElement;
        lblctrl.click();
      }
      this.lblComErrorePALHardwareId = "";
      this.ePALcommission.testBuildingId = this.txtMdlePALTestBldId.trim();
      this.ePALcommission.buildingId = this.lblMdlBldId;
      this.ePALcommission.epalHardwareId = this.txtMLePALHardwareId.trim();
      this.ePALcommission.deviceApplicationType = this.appContentSelectedValue.trim();
      this.ePALcommission.eloViewSerialNumber = this.txtMLEloviewSerialNum.trim();
      this.ePALcommission.simcardICCID1 = this.txtGWMlIccId != null ? this.txtGWMlIccId.trim() : "";
      this.ePALcommission.simcardICCID2 = this.txtGWMlIccId2 != null ? this.txtGWMlIccId2.trim() : "";
      this.ePALcommission.isNewDevice = this.txtEloViewDevice != "" ? false : true;
      this.ePALcommission.eloVersionNumber = this.selEloVersionNumber;
      
      this.apiService
        .ePALCommissioning(this.ePALcommission)
        .subscribe((data: any) => {
          if (data.trim().toLocaleLowerCase() === "success") {
            if(this.selEloVersionNumber === 3){
                this.showSuccessMessage();
            }
            else{
                setTimeout(() => {
                  this.showSuccessMessage();
                }, 5000);
            }            
          }
          else {
            this.toastr.showError("ePAL Device Commission Failed !!");
            this.isBtnStartEpal = true;
            this.isBtnEndEpal = false;
          }
        });
    }
  }

  showSuccessMessage(){
    this.toastr.showSuccess("Successfully Commissioned ePAL Device with Test Building !!");
    this.getEloViewDevices(true);
  }
  onEpalCommValidation(): boolean {
    if (this.txtMLePALHardwareId === null || this.txtMLePALHardwareId === undefined || this.txtMLePALHardwareId.trim() === "") {
      this.lblComErrorePALHardwareId = "Enter ePAL HardwareId";
      return false;
    }
    else {
      this.lblComErrorePALHardwareId = "";
    }

    if (this.txtMdlePALTestBldId === null || this.txtMdlePALTestBldId === undefined || this.txtMdlePALTestBldId.trim() === "") {
      this.lblComErrorTestBldId = "Enter Test Building Id";
      return false;
    }
    else {
      this.lblComErrorTestBldId = "";
    }

    if (this.txtMLEloviewSerialNum === null || this.txtMLEloviewSerialNum === undefined || this.txtMLEloviewSerialNum.trim() === "") {
      this.lblMLEloviewSerialNum = "Enter EloView Serial Number";
      return false;
    }
    else {
      this.lblMLEloviewSerialNum = "";
    }

    if (this.appContentSelectedId.toString() === "0") {
      this.appContentError = "Select Device Application Type";
      return false;
    }
    else {
      this.appContentError = "";
    }
    return true;
  }

  //ePAL HwID De-commission for Production Building Id

  onDecommissionePALHardwareId() {
    if (this.txtEpalHardwareId !== null && this.txtEpalHardwareId.trim() !== ""
      && this.txtEpalHardwareId !== undefined && this.ePALBuildingDetails.buildingId != undefined) {
      this.epalDecommission.epalHardwareId = this.deComEpalHwId;
      this.epalDecommission.buildingId = this.ePALBuildingDetails.buildingId;
      this.apiService
        .ePALDeCommissioning(this.epalDecommission)
        .subscribe((data: any) => {
          if (data == true) {
            this.toastr.showSuccess("Successfully Decommissioned !!");
            this.modalClose("modal close");
            this.getGridDataByFilterSearch();
            this.isBtnEndEpal = false;
          }
          else {
            this.toastr.showError("Decommission Failed !!");
          }
        });
    }
    else {
      if (this.txtEpalHardwareId !== null && this.txtEpalHardwareId.trim() === ""
        && this.txtEpalHardwareId !== undefined) { this.lblDeComErrorePALHardwareId = "Enter ePAL HardwareId"; }
      else if (this.ePALBuildingDetails.buildingId === undefined && this.txtEpalHardwareId.trim() !== "") { this.lblDeComErrorePALHardwareId = "Enter valid ePAL HardwareId"; }
    }
  }

  //ePAL HwID DeCommission for Test Building Id and Comm for Production Building Id
  onEPALCommAndDeComm() {
    if (this.onEpalCommValidation()) {
      this.ePALDecomAndComm.buildingId = this.lblMdlBldId;
      this.ePALDecomAndComm.testBuildingId = this.txtMdlePALTestBldId.trim();
      this.ePALDecomAndComm.epalHardwareId = this.txtMLePALHardwareId.trim();
      this.ePALDecomAndComm.deviceApplicationType = this.appContentSelectedValue.trim();
      this.ePALDecomAndComm.eloViewSerialNumber = this.txtMLEloviewSerialNum.trim();
      this.ePALDecomAndComm.eloVersionNumber = this.selEloVersionNumber;

      this.apiService
        .ePALDeCommAndCommission(this.ePALDecomAndComm)
        .subscribe((data: string) => {
          if (data.trim().toLocaleLowerCase() === "success") {
            this.toastr.showSuccess("Successfully Commissioned ePAL Device With Production Building !!");
          }
          else {
            this.toastr.showError(data);
          }
        });
    }
  }

  getBuildingUnitsSearch() {
    if (this.txtEpalHardwareId !== null && this.txtEpalHardwareId.trim() !== "" && this.txtEpalHardwareId !== undefined) {
      this.lblDeComErrorePALHardwareId = "";
      this.deComEpalHwId = this.txtEpalHardwareId;

      this.apiService
        .getBuildingUnitDetailsByePALHwId(this.txtEpalHardwareId)
        .subscribe((data: any) => {
          if (data != null) {           
            this.ePALBuildingDetails.buildingId = data["buildingId"];
            this.ePALBuildingDetails.buildingName = data["buildingName"];
            this.ePALBuildingDetails.eloviewSerialNumber = data["eloviewSerialNumber"];
            this.ePALBuildingDetails.simCardICCID1 = data["simCardICCID1"];
            this.ePALBuildingDetails.simCardICCID2 = data["simCardICCID2"];
            this.ePALBuildingDetails.Units = data["units"];
          }
          else {
            this.toastr.showInformation("No Records Found for a given ePAL HardwareId : " + this.txtEpalHardwareId);
            this.ePALBuildingDetails = new EpalUnitDetails();
          }
        });
    }
    else {
      this.lblDeComErrorePALHardwareId = "Enter ePAL HardwareId";
    }
  }

  resetDeCommModal() {
    this.lblDeComErrorePALHardwareId = "";
    this.txtEpalHardwareId = "";
    this.ePALBuildingDetails = new EpalUnitDetails();
  }

  resetCommModal() {
    this.expandedCommissionedDeviceIndex = -1;
    this.txtMLePALHardwareId = "";
    this.txtMdlePALTestBldId = "";
    this.txtMLEloviewSerialNum = "";
    this.txtGWMlIccId = "";
    this.txtGWMlIccId2 = "";
    this.isBtnStartEpal = true;
    this.isBtnEndEpal = false;
    this.appContentSelectedId = 0;
    this.lblMLEloviewSerialNum = "";
    this.appContentError = "";
    this.eloViewDeviceError = "";
    this.lblICCID2error = "";
    this.lblICCID2success = "";
    this.txtEloViewDevice = "";
    this.temptxtEloViewDevice = "";
    this.eloViewDeviceID = "";
    this.selEloVersionNumber = 3;
    this.isEnvironmentDisabled = false;
    this.setAppContentBasedOnVersion();
  }

  resetCommissionModal() {
    this.expandedCommissionedDeviceIndex = -1;
    this.txtEloViewDevice = "";
    this.temptxtEloViewDevice = "";
    this.eloViewDeviceID = "";
    this.isEnvironmentDisabled = false;
    this.txtMLEloviewSerialNum = "";
    this.lblMLEloviewSerialNum = "";
    this.eloViewDeviceError = "";
  }

  onInstallApkToDevice() {
    if (this.onInstallApkToDeviceValidation()) {
      this.ePALAddContentToDevice.deviceId = this.eloViewDeviceID;
      this.ePALAddContentToDevice.contentId = this.appContentSelectedId.toString();
      this.ePALAddContentToDevice.buildingId = this.lblMdlBldId;
      this.ePALAddContentToDevice.deviceApplicationType = this.appContentSelectedValue.trim();
      this.ePALAddContentToDevice.eloViewDevice = this.txtEloViewDevice;
      this.ePALAddContentToDevice.eloViewSerialNumber = this.txtMLEloviewSerialNum.trim();
      this.ePALAddContentToDevice.eloVersionNumber = this.selEloVersionNumber;
      this.ePALAddContentToDevice.testBuildingId = this.txtMdlePALTestBldId.trim();
      this.ePALAddContentToDevice.epalHardwareId = this.txtMLePALHardwareId.trim();

      this.apiService
        .addContentToDevice(this.ePALAddContentToDevice)
        .subscribe((data: any) => {
          if (data == true) {
            this.toastr.showSuccess("APK Content Successfully installed into the Device!!");
          }
          else {
            this.toastr.showError("Content Installation Failed!!");
          }
        });
    }
  }

  onInstallApkToDeviceValidation(): boolean {
    if (this.txtMLEloviewSerialNum === null || this.txtMLEloviewSerialNum === undefined || this.txtMLEloviewSerialNum.trim() === "") {
      this.lblMLEloviewSerialNum = "Enter EloView Serial Number";
      return false;
    }
    else {
      this.lblMLEloviewSerialNum = "";
    }
    if (this.appContentSelectedId.toString() === "0") {
      this.appContentError = "Select Device Application Type";
      return false;
    }
    else {
      this.appContentError = "";
    }
    if (this.txtEloViewDevice === null || this.txtEloViewDevice === undefined || this.txtEloViewDevice.trim() === "") {
      this.eloViewDeviceError = "Search EloView Device";
      return false;
    }
    else {
      this.eloViewDeviceError = "";
    }
    return true;
  }

  onDeviceReboot() {
    if (this.txtMLEloviewSerialNum !== null && this.txtMLEloviewSerialNum.trim() !== "" && this.txtMLEloviewSerialNum !== undefined) {
      this.ePALDeviceReboot.eloViewSerialNumber = this.txtMLEloviewSerialNum.trim();
      this.ePALDeviceReboot.buildingId = this.lblMdlBldId;
      this.ePALDeviceReboot.eloVersionNumber = this.selEloVersionNumber;
      this.ePALDeviceReboot.testBuildingId = this.txtMdlePALTestBldId.trim();
      this.ePALDeviceReboot.epalHardwareId = this.txtMLePALHardwareId.trim();
      this.lblMLEloviewSerialNum = "";

      this.apiService
        .eloViewDeviceReboot(this.ePALDeviceReboot)
        .subscribe((data: any) => {
          if (data == true) {
            this.toastr.showSuccess("Reboot Successful !!");
          }
          else {
            this.toastr.showError("Reboot Failed !!");
          }
        });
    }
    else {
      this.lblMLEloviewSerialNum = "Enter EloView SerialNumber";
    }
  }

  gatewayTypeSelectChanged($event) {
    this.gatewayTypeSelectedId = $event.target.value;
    this.gatewayTypeSelectedValue = $event.target.options[$event.target.selectedIndex].text;
    this.txtGWMlMacAdd = "test";
    this.gatewayTypeSelectedValue === "DIGI-WR21" ? this.txtGWMlMacAdd = "00042D" : (this.gatewayTypeSelectedValue === "DIGI-EX12" ? this.txtGWMlMacAdd = "002704" : (this.gatewayTypeSelectedValue === "DIGI-EX15" ? this.txtGWMlMacAdd = "002704" : this.txtGWMlMacAdd = ""));
    this.getGatewayFirmwareVersionName(Number(this.gatewayTypeSelectedId));
  }
  clearErrorMessages() {
    this.lblICCID1error = "";
    this.lblICCID1success = "";
    this.lblICCID2error = "";
    this.lblICCID2success = "";
    this.lblVerizonStatus = "";
    this.lblATTStatus = "";
    this.isVerizonActivation = false;
    this.isATTActivation = false;
  }

  //get Device using Gateway
  getDeviceGatewayTypes() {
    this.masterDataService
      .getDeviceGateway()
      .subscribe((data: any) => {
        this.Devicegateway = data.slice(1);
      });
  }

  //Get gateway types
  getGatewayTypes() {
    this.masterDataService
      .getGatewayType()
      .subscribe((data: any) => {
        this.gatewayTypes = data.filter(x => x.id != 5);
      });
  }

  AssignEpalGateway($event) {
    if (this.assignEpalGatewayValidations()) {
      this.isInvalidSim1 = false;
      this.isInvalidSim2 = false;
      if (this.lblICCID1error != "") {
        this.txtGWMlIccId = "";
        this.lblICCID1error = "";
        this.isInvalidSim1 = true;
      }
      if (this.lblICCID2error != "") {
        this.txtGWMlIccId2 = "";
        this.lblICCID2error = "";
        this.isInvalidSim2 = true;
      }
      this.assignEpalGateway.elevatorUnitNumber = this.selectedUnits;
      this.assignEpalGateway.gatewayTypeId = this.gatewayTypeSelectedId;
      this.assignEpalGateway.gatewayMacAddress = this.txtGWMlMacAdd;
      this.assignEpalGateway.simcardIccId = this.txtGWMlIccId;
      this.assignEpalGateway.simcardIccId2 = this.txtGWMlIccId2;
      this.assignEpalGateway.buildingId = this.rowSelectedData["buildingId"];
      this.assignEpalGateway.buildingName = this.rowSelectedData["buildingName"];
      this.assignEpalGateway.password = this.txtGWPwd;
      this.assignEpalGateway.deviceGatewayTypeId = this.devicegatewayTypeSelId;

      this.apiService
        .ePALAssignGateway(this.assignEpalGateway)
        .subscribe((data: any) => {
          this.lblICCID1success = "";
          this.lblICCID2success = "";
          this.rowData = data;
          if (data != null && data.item1 == true) {
            this.toastr.showSuccess("ePAL Gateway assigned successfully !!");
            this.getEpalGatewayInfo(this.rowSelectedData);
            setTimeout(() => {
              this.checkDIGIFirmwareVersion();
            }, 10000);
            if (data.item3 != null && data.item3 != "" && this.gatewayUpdateEnabled == false && this.txtGWMlIccId.length === 20) {
              this.isATTActivation = true;
              this.lblATTStatus = "AT&T SIM Card Successfully Activated.";
              setTimeout(() => {
                if (this.txtGWMlIccId.trim() !== "" && this.txtGWMlIccId.trim().length == 20) {
                  this.checkATTDeviceAvailability();
                }
              }, 300000);
            }
            else if ((data.item3 == null || data.item3 == "") && this.txtGWMlIccId !== "") {
              this.isATTActivation = false;
              this.txtGWMlIccId = "";
              this.lblATTStatus = "AT&T SIM Card Activation Failed.";
            }
            if (data.item2 != null && data.item2 != "" && this.gatewayUpdateEnabled == false && this.txtGWMlIccId2.length === 20) {
              this.isVerizonActivation = true;
              this.lblVerizonStatus = "Verizon SIM Card activation is currently in progress. Please wait 3–5 minutes and check the status on this screen.";
              setTimeout(() => {
                if (this.txtGWMlIccId2.trim() !== "" && this.txtGWMlIccId2.trim().length == 20) {
                  this.checkVerizonDeviceAvailability();
                }
              }, 300000);
            }
            else if ((data.item2 == null || data.item2 == "") && this.txtGWMlIccId2 !== "") {
              this.isVerizonActivation = false;
              this.txtGWMlIccId2 = "";
              this.lblVerizonStatus = "Verizon SIM Card Activation Failed.";
            }
            this.gatewayUpdateEnabled = true;
            if (this.gatewayUpdateEnabled && this.isInvalidSim1) {
              setTimeout(() => {
                this.toastr.showInformation("SIM ICCID1 not found in the AT&T system. Please update SIM details offline");
                this.isInvalidSim1 = false;
              }, 5000);
            }
            if (this.gatewayUpdateEnabled && this.isInvalidSim2) {
              setTimeout(() => {
                this.toastr.showInformation("SIM ICCID2 not found in the Verizon system. Please update SIM details offline");
                this.isInvalidSim2 = false;
              }, 5000);
            }
          }
          else {
            this.toastr.showError("Gateway Assign Failed !!");
          }
        });
    }
  }

  assignEpalGatewayValidations(): boolean {
    this.txtGWMlMacAdd = this.txtGWMlMacAdd.replace(/\:/g, "").trim();

    if (this.txtGWMlMacAdd.length !== 12) {
      this.lblErrorGWMLMacAdd = "Gateway Mac Address should be 12 characters length";
      return false;
    }
    else {
      this.lblErrorGWMLMacAdd = "";
    }
    return true;
  }

  onEpalDecommission($event) {
    this.ePALGatewayDecommission.buildingId = $event["buildingId"];
    this.ePALGatewayDecommission.gatewayMacAddress = $event["gatewayMacAddress"];
    this.ePALGatewayDecommission.deviceGatewayTypeId = $event["deviceGatewayTypeId"];

    if (confirm("Are you sure want to to Decommission ePAL Gateway MacAddress: " + this.ePALGatewayDecommission.gatewayMacAddress + " for the BuildingId: " + this.ePALGatewayDecommission.buildingId)) {
      {
        this.apiService
          .ePALGatewayDeCommission(this.ePALGatewayDecommission)
          .subscribe((data: any) => {
            if (data == true) {
              this.toastr.showSuccess("Successfully Decommissioned ePAL Gateway MacAddress!!");
              this.getEpalGatewayInfo(this.rowSelectedData);
              this.ClearValuesOnsave();
            }
            else {
              this.toastr.showError("ePAL Gateway Decommission Failed !!");
            }
          });
      }
    }
  }

  //ePAl Gateway Modal
  ePALGatewayModalLoad(rowSelectedData) {
    this.getEpalGatewayInfo(rowSelectedData)
  }

  //Get ePAL Assigned Gateways Data
  getEpalGatewayInfo(rowSelectedData) {
    var lblePalMdlBldId = (rowSelectedData["buildingId"] !== null && rowSelectedData["buildingId"] !== undefined) ? rowSelectedData["buildingId"] : "";

    if (lblePalMdlBldId !== null && lblePalMdlBldId !== "" && lblePalMdlBldId !== undefined) {
      this.apiService
        .getEpalGatewayInfoByBuildingId(lblePalMdlBldId)
        .subscribe((data: any) => {
          if (data != null) {
            this.ePALCommissionedGateways = data;
          }
          else {
            this.ePALCommissionedGateways = [];
          }
        });
    }
  }

  onUpdateFirmware($event) {
    this.checkDIGIFirmwareVersion();
  }

  onReset($event) {
    this.ClearValuesOnsave();
    this.getGatewayFirmwareVersionName(Number(this.gatewayTypeSelectedId));
  }

  checkDIGIFirmwareVersion() {
    if (this.txtGWMlMacAdd.length > 6) {
      this.apiService
        .getDigiFirmwareVersion(this.txtGWMlMacAdd)
        .subscribe((data: any) => {
          this.txtECSuggestedVersion = data;
          this.DisplayValidMessages();
          if (this.txtECSuggestedVersion == '' || this.txtECSuggestedVersion == null) {
            setTimeout(() => {
              this.lblVersionMessage = "Firmware version not reported to DRM. Make sure Digi is online. Click on Get Firmware Version to check DRM status.";
              this.isVersionMatch = false;
            }, 5000);
          }
          else if (this.txtECfwVersion.replace(/ /g, '').split(',').indexOf(this.txtECSuggestedVersion) > -1) {
            this.lblVersionMessage = "This Gateway has compatible firmware listed in DRM.";
            this.isVersionMatch = true;
          }
          else {
            setTimeout(() => {
              this.lblVersionMessage = "Running Firmware Version from DRM & Otis ONE Compatible Firmware versions are different. Manually update firmware if needed. Click on Get Firmware Version to check Gateway reported version to DRM.";
              this.isVersionMatch = false;
            }, 5000);
          }
        });
    }
  }

  DisplayValidMessages() {
    if (this.txtECSuggestedVersion == "" || this.txtECSuggestedVersion == null) {
      this.toastr.showInformation("Firmware version not reported to DRM. Make sure Digi is online.");
    }
    else {
      this.toastr.showSuccess("Running Firmware Version from DRM Updated successfully !!");
    }
  }

  onEpalDeviceSearch() {
    this.appContentError = "";
    if (this.txtMLEloviewSerialNum === null || this.txtMLEloviewSerialNum === undefined || this.txtMLEloviewSerialNum.trim() === "") {
      this.lblMLEloviewSerialNum = "Enter EloView Serial Number";
      return false;
    }
    else {
      this.lblMLEloviewSerialNum = "";
      this.getEloViewDevices(false);
    }
  }

  onTabChange(event: MatTabChangeEvent) {
    this.tabGroup._tabs.toArray()[3].disabled = true;
    const tab = event.tab.textLabel;
    if (tab === "ePAL Commission") {
      this.tabGroup._tabs.toArray()[0].disabled = true;
      this.tabGroup._tabs.toArray()[1].disabled = false;
      this.bindDefaultValuesOnLoad();
      this.bindGridOnPageLoad();
    }
    else if (tab === "EloView Sync") {
      this.tabGroup._tabs.toArray()[0].disabled = false;
      this.tabGroup._tabs.toArray()[1].disabled = true;
      this.eloViewSyncInfo.resetFilters();
    }
    else {
      this.tabGroup._tabs.toArray()[0].disabled = true;
      this.tabGroup._tabs.toArray()[1].disabled = true;
    }

  }

  checkUserPermissions() {
    this.permissionService.loadUserPermissions().subscribe((permissions) => {
      this.enableEloViewSync = permissions['ePAL'] || false;
      this.eloViewSync = this.enableEloViewSync ? "EloView Sync" : "";
    });
  }

 onATTDeviceSearch() {
    if (!this.txtGWMlIccId) {
      this.lblICCID1error = "";
      this.lblICCID1success = "";
      return;
    }

    this.txtGWMlIccId = this.txtGWMlIccId.replace(/\:/g, "").trim();

    if (this.txtGWMlIccId.length !== 0 && this.txtGWMlIccId.length !== 20) {
      this.lblICCID1error = "AT&T SIM Card ICCID length should be 20 characters";
      this.lblICCID1success = "";
      return false;
    }
    else if (this.txtGWMlIccId.length == 20) {
      this.lblICCID1error = "";
      this.checkATTDeviceAvailability(() => {
        if ((this.attDeviceInfo == null || this.attDeviceInfo.iccid == null || this.attDeviceInfo.iccid == "")) {
          this.lblICCID1error = "Device does not exist in AT&T System";
          this.lblICCID1success = "";
        }
        else if (this.attDeviceInfo.iccid != null && this.attDeviceInfo.iccid != "") {
          this.lblICCID1error = "";
          this.lblICCID1success = "Device exists in AT&T System";
        }
      });
    }
  }

  onVerizonDeviceSearch() {
    this.txtGWMlIccId2 = this.txtGWMlIccId2.replace(/\:/g, "").trim();

    if (this.txtGWMlIccId2.length !== 0 && this.txtGWMlIccId2.length !== 20) {
      this.lblICCID2error = "Verizon SIM Card ICCID length should be 20 characters";
      this.lblICCID2success = "";
      return false;
    }
    else if (this.txtGWMlIccId2.length == 20) {
      this.lblICCID2error = "";
      this.checkVerizonDeviceAvailability(() => {
        if ((this.verizonDeviceInfo == null || this.verizonDeviceInfo.devices == null || this.verizonDeviceInfo.devices.length == 0)) {
          this.lblICCID2error = "Device does not exist in Verizon System";
          this.lblICCID2success = "";
          this.lblVerizonStatus = "";
        }
        else if (this.verizonDeviceInfo.devices != null && this.verizonDeviceInfo.devices.length > 0) {
          this.lblICCID2error = "";
          this.lblICCID2success = "Device exists in Verizon System";
          this.lblVerizonStatus = "";
        }
      });
    }
  }

  checkATTDeviceAvailability(onComplete?: () => void) {
    this.apiService
      .checkATTDeviceStatus(this.txtGWMlIccId.trim())
      .subscribe((data: any) => {
        if (data != null) {
          this.attDeviceInfo = data;
        }
        else {
          this.attDeviceInfo = [];
        }
        if (onComplete) {
          onComplete();
        }
      });
  }

  checkVerizonDeviceAvailability(onComplete?: () => void) {
    this.apiService
      .checkVerizonDevice(this.txtGWMlIccId2.trim())
      .subscribe((data: any) => {
        if (data != null) {
          this.verizonDeviceInfo = data;
        }
        else {
          this.verizonDeviceInfo = [];
        }
        if ((data.devices == null || data.devices.length == 0) && this.gatewayUpdateEnabled) {
          this.lblVerizonStatus = "Verizon SIM Card Activation Failed";
          this.lblICCID2error = "";
          this.lblICCID2success = "";
          this.txtGWMlIccId2 = "";
          this.isVerizonActivation = false;
        }
        else if (data.devices != null && data.devices.length > 0 && this.gatewayUpdateEnabled) {
          this.lblICCID2error = "";
          this.lblICCID2success = "";
          this.lblVerizonStatus = "Verizon SIM Card Successfully Activated.";
          this.isVerizonActivation = true;
        }
        if (onComplete) {
          onComplete();
        }
      });
  }

  toggleCommissionedDeviceSimInfo(index: number) {
    this.expandedCommissionedDeviceIndex = this.expandedCommissionedDeviceIndex === index ? -1 : index;
  }

  hasCommissionedDeviceSimInfo(device: any): boolean {
    return this.getCommissionedDeviceSimValue(device, ["simCardICCID1"]) !== ""
      || this.getCommissionedDeviceSimValue(device, ["simCardICCID2"]) !== "";
  }

  getCommissionedDeviceSim1(device: any): string {
    return this.getCommissionedDeviceSimValue(device, ["simCardICCID1"]);
  }

  getCommissionedDeviceSim2(device: any): string {
    return this.getCommissionedDeviceSimValue(device, ["simCardICCID2"]);
  }

  getCommissionedDeviceVerizonStatus(device: any): string {
    const verizonStatus = device["verizonSimCardStatus"];

    if (verizonStatus === true) {
      return "Active";
    }

    if (verizonStatus === false) {
      return "Inactive";
    }

    if (verizonStatus !== null && verizonStatus !== undefined && verizonStatus.toString().trim() !== "") {
      return verizonStatus.toString().trim();
    }

    return "Not Available";
  }

  private getCommissionedDeviceSimValue(device: any, keys: string[]): string {
    for (const key of keys) {
      const value = device[key];
      if (value !== null && value !== undefined && value.toString().trim() !== "") {
        return value.toString().trim();
      }
    }

    return "";
  }
}             
